import { useState, useEffect } from "react";
import styles from "./styles.module.scss";

const ErrorIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
    <path d="M15 9L9 15M9 9L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const SuccessIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
    <path d="M8 12L11 15L16 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const getVariant = (type) => {
  if (type?.includes("success")) return "success";
  return "error";
};

const TITLES = {
  error: "Error",
  success: "Success",
};

const AlertMessage = ({ alertMessage }) => {
  const [hiding, setHiding] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (alertMessage.message) {
      setVisible(true);
      setHiding(false);

      const hideTimer = setTimeout(() => {
        setHiding(true);
        setTimeout(() => setVisible(false), 400);
      }, 6000);

      return () => clearTimeout(hideTimer);
    } else {
      setVisible(false);
    }
  }, [alertMessage]);

  const handleClose = () => {
    setHiding(true);
    setTimeout(() => setVisible(false), 400);
  };

  if (!visible || !alertMessage.message) return null;

  const variant = getVariant(alertMessage.type);
  const Icon = variant === "success" ? SuccessIcon : ErrorIcon;
  const iconClass = variant === "success" ? styles.successIcon : styles.errorIcon;

  return (
    <div className={`${styles.toast} ${styles[variant]} ${hiding ? styles.hiding : ""}`} role="alert">
      <Icon className={`${styles.icon} ${iconClass}`} />
      <div className={styles.content}>
        <p className={styles.title}>{TITLES[variant]}</p>
        <p className={styles.message}>{alertMessage.message}</p>
      </div>
      <button className={styles.close} onClick={handleClose} type="button" aria-label="Close">
        ×
      </button>
    </div>
  );
};

export default AlertMessage;
